import React from 'react';

import { Button } from '@mui/material';

import { useCustomReactFlowState } from '../../context/reactflow-context';

const SaveButton: React.FC = () => {
  const { isReadOnly } = useCustomReactFlowState();

  return (
    <Button
      disabled={isReadOnly}
      type="submit"
      variant="contained"
      color="primary"
      sx={{
        marginRight: '20px',
      }}
    >
      Save
    </Button>
  );
};

export default SaveButton;
